import { ArtistFilterParams } from "../types/artist-filter-params";
import { Beat, Filter } from "@/models/models";
import { useEffect } from "react";
import { getBeatsAsync } from "@/lib/beats-manager";
import { FilterType, ItemStatus } from "@/models/enums";
import { usePaginationQuery } from "../../../lib/hooks/usePaginationQuery";
import toast from "react-hot-toast";

export type UseArtistBeatsParams = ArtistFilterParams<Beat[]>;

export const useArtistBeats = ({
  pageSize,
  id,
  sorting,
}: UseArtistBeatsParams) => {
  const { data, reset, ...rest } = usePaginationQuery<Beat[]>({
    key: ["/artist/beats", { id, sorting }],
    fetcher: async ({ offset }) => {
      const { beats } = await getBeatsAsync(
        undefined,
        [{ id, type: FilterType.artistType }] as Filter[],
        sorting,
        undefined,
        pageSize ?? 40,
        offset ?? 0,
        ItemStatus.Published,
        false
      );
      return beats;
    },
    pageSize: 40,
    onError() {
      toast.error("Failed to get beats.");
    },
  });

  useEffect(() => {
    // When sorting changes, we need to clear all data and refetch
    reset();
  }, [sorting, reset]);

  useEffect(() => {
    // When ArtistPicker switches impersonated user this reset will trigger
    if (id) {
      reset();
    }
  }, [id, reset]);

  return { beats: data, reset, ...rest };
};

export default useArtistBeats;
